import React from "react";
import {useTranslation} from "gatsby-plugin-react-i18next";
import FaqList from "../../components/shared/faq-list";

const FAQ = () => {
    const {t} = useTranslation();

    const items = [
        {
            id: "what",
            question: t("What is ChatLab?"),
            answer: t("ChatLab is a no-code AI chatbot platform that helps businesses provide 24/7 customer support without technical expertise. Create AI-powered chatbots trained on your business data in minutes, with support for 80+ languages, e-commerce integrations, live chat escalation, and lead collection."),
        },
        {
            id: "how",
            question: t("How does ChatLab work?"),
            answer: t("ChatLab works in 3 simple steps: 1) Train your chatbot by adding your website URL, uploading documents, or entering Q&A pairs. 2) Customize the appearance and personality to match your brand. 3) Copy the embed code and paste it on your website. The AI chatbot learns from your business data and answers customer questions automatically, using the AI model you choose from OpenAI, Google Gemini or Anthropic Claude."),
        },
        {
            id: "cost",
            question: t("How much does ChatLab cost?"),
            answer: t("ChatLab offers flexible pricing: Free plan (100 messages/month), Basic at $18/month (2,400 messages), Standard at $95/month (11,000 messages with analytics and integrations), and Premium at $360/month (50,000 messages with white-label and agency features). All plans include a free trial with no credit card required."),
        },
        {
            id: "languages",
            question: t("Is there support for other languages?"),
            answer: t("Yes, you can train the chatbot in any language. You can provide additional instructions to the chatbot to answer only in selected language. By default the chatbot answers in the language of the question. That is also the case when the language of the question is different than the language in which the chatbot has been trained. This means that you can train the chatbot in English and it will answer in Spanish if asked in Spanish."),
        },
        {
            id: "code",
            question: t("Do I need to code to use ChatLab? How to add AI chatbot to website?"),
            answer: t("No. ChatLab serves as a no-code platform for creating AI chatbots. You can design your personalized custom website chatbot widget with our AI chatbot builder in less than five minutes and then integrate it into your website."),
        },
        {
            id: "models",
            question: t("Which AI models does ChatLab use"),
            answer: t("ChatLab uses by default GPT-5.6 Luna. In paid plans you can also use following models:"),
            list: [
                "OpenAI: GPT-5.6 Sol, GPT-5.6 Terra, GPT-5.6 Luna, GPT-5.5, GPT-5.4, GPT-5.4-mini, GPT-5.1, GPT-5, GPT-5-mini, GPT-4.1, GPT-4.1-mini, GPT-4o, GPT-4o-mini",
                "Google: Gemini 3 Pro, Gemini 3.8 Flash, Gemini 3.7 Flash, Gemini 3.5 Flash, Gemini 3 Flash, Gemini 3.1 Flash-Lite, Gemini 2.5 Pro",
                "Anthropic: Claude Opus 4.7, Claude Sonnet 4.6, Claude Haiku 4.5",
            ],
        },
        {
            id: "backend",
            question: t("Can I integrate the ChatLab AI chatbot with my custom backend system?"),
            answer: t("Using our AI actions editor you can build any custom integration with any backend system that can expose the data via API endpoints. For example you can make the chatbot to check the availability of the product in your warehouse, check the status of the order in your ERP system, or check the current balance on the customer account. In case you need more extended integration, please contact us."),
        },
        {
            id: "gdpr",
            question: t("Is ChatLab GDPR compliant? Is my data safe?"),
            answer: t("Yes, ChatLab is committed to GDPR compliance, ensuring that your data is handled in accordance with European data protection regulations. We have implemented robust security measures to protect your personal information from unauthorized access. For detailed information, please refer to our article on safety on our"),
            link: {to: "/blog/gdpr/", label: t("GDPR Information article")},
        },
    ];

    return (
        <FaqList
            id="faq"
            items={items}
            eyebrow={t("Questions")}
            title={t("Frequently asked|questions.")}
        />
    );
};

export default FAQ;
